import store from "../store";

export default {
  install(Vue) {
    Vue.prototype.$api = {
      adminLogin: (data) => {
        return store.dispatch("axi/request", {
          method: "post",
          url: "/admin/api/user/login",
          data: data,
        });
      },
      mfaAuth: (data) => {
        return store.dispatch("axi/request", {
          method: "post",
          url: "/admin/api/user/mfa",
          data: data,
        });
      },
      adminLogout: () => {
        return store.dispatch("axi/request", {
          method: "post",
          url: "/admin/api/user/logout",
        });
      },
      postsList: (data) => {
        return store.dispatch("axi/request", {
          method: "get",
          url: "/admin/api/posts/list",
          params: data,
        });
      },
      postsStatus: (data) => {
        return store.dispatch("axi/request", {
          method: "post",
          url: "/admin/api/posts/status",
          data: data,
        });
      },
      postsShow: (data) => {
        return store.dispatch("axi/request", {
          method: "get",
          url: "/admin/api/posts/show",
          params: data,
        });
      },
      postsStore: (data) => {
        return store.dispatch("axi/request", {
          method: "post",
          url: "/admin/api/posts/store",
          data: data,
        });
      },
      postsUpdate: (data) => {
        return store.dispatch("axi/request", {
          method: "post",
          url: "/admin/api/posts/update",
          data: data,
        });
      },
      postsDelete: (data) => {
        return store.dispatch("axi/request", {
          method: "post",
          url: "/admin/api/posts/delete",
          data: data,
        });
      },
      postsPublish: (data) => {
        return store.dispatch("axi/request", {
          method: "post",
          url: "/admin/api/posts/publish",
          data: data,
        });
      },
      categorySelect: () => {
        return store.dispatch("axi/request", {
          method: "get",
          url: "/admin/api/category/select",
        });
      },
      categoryList: () => {
        return store.dispatch("axi/request", {
          method: "get",
          url: "/admin/api/category/list",
        });
      },
      categoryStatus: () => {
        return store.dispatch("axi/request", {
          method: "get",
          url: "/admin/api/category/status",
        });
      },
      categoryStore: (data) => {
        return store.dispatch("axi/request", {
          method: "post",
          url: "/admin/api/category/store",
          data: data,
        });
      },
      webPostsList: (data) => {
        return store.dispatch("axi/request", {
          method: "get",
          url: "/api/posts/list",
          params: data,
        });
      },
      webPostsShow: (data) => {
        return store.dispatch("axi/request", {
          method: "get",
          url: "/api/posts/show",
          params: data,
        });
      },
    };
  },
};
